export default __webpack_public_path__ + "dp-white.f85ac29.png";